"use client";

import { useSyncExternalStore } from "react";
import { VideoWidget } from "./video-widget";

/**
 * Banc du widget vidéo tant qu'aucune séance ne l'alimente, en dev seulement :
 * `/studio?widget=video` (avant le flux) et `/studio?widget=video-live` (un
 * faux flux, dessiné dans un canvas).
 */
export function VideoWidgetDemo({ live }: { live: boolean }) {
  return live ? <LiveDemo /> : <VideoWidget name="Camille Laurent" />;
}

function LiveDemo() {
  const stream = useSyncExternalStore(subscribe, getSnapshot, () => null);

  return <VideoWidget name="Camille Laurent" stream={stream} />;
}

// Un seul faux flux, démarré au premier abonné et arrêté au dernier : le
// magasin externe évite le `setState` dans un effet, et le rendu serveur ne
// voit jamais de flux, donc l'hydratation ne diverge pas.
let stream: MediaStream | null = null;
let frame = 0;
let subscribers = 0;

function subscribe(listener: () => void): () => void {
  subscribers += 1;

  if (stream === null) {
    stream = startDemoStream();
    listener();
  }

  return () => {
    subscribers -= 1;

    if (subscribers === 0 && stream !== null) {
      cancelAnimationFrame(frame);

      for (const track of stream.getTracks()) {
        track.stop();
      }

      stream = null;
    }
  };
}

function getSnapshot(): MediaStream | null {
  return stream;
}

function startDemoStream(): MediaStream {
  const canvas = document.createElement("canvas");
  canvas.width = 640;
  canvas.height = 360;
  const context = canvas.getContext("2d");

  const draw = (now: number) => {
    if (context !== null) {
      const t = now / 1000;
      const gradient = context.createLinearGradient(0, 0, 640, 360);
      gradient.addColorStop(0, "#1b1530");
      gradient.addColorStop(1, "#0d1a24");
      context.fillStyle = gradient;
      context.fillRect(0, 0, 640, 360);

      // Une silhouette qui respire, pour qu'on voie que l'image vit.
      context.fillStyle = "rgba(255, 255, 255, 0.14)";
      context.beginPath();
      context.arc(320 + Math.sin(t) * 18, 150, 54, 0, Math.PI * 2);
      context.fill();
      context.beginPath();
      context.ellipse(320 + Math.sin(t) * 18, 360, 150, 120, 0, 0, Math.PI * 2);
      context.fill();
    }

    frame = requestAnimationFrame(draw);
  };

  frame = requestAnimationFrame(draw);

  return canvas.captureStream(30);
}
